import { render } from "./ProductPhotosGallery.vue?vue&type=template&id=01c85888&scoped=true"
import script from "./ProductPhotosGallery.vue?vue&type=script&lang=js"
export * from "./ProductPhotosGallery.vue?vue&type=script&lang=js"

import "./ProductPhotosGallery.vue?vue&type=style&index=0&id=01c85888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c85888"]])

export default __exports__